import { render, staticRenderFns } from "./SearchDialog.vue?vue&type=template&id=4de5b6f4&scoped=true"
import script from "./SearchDialog.vue?vue&type=script&lang=js"
export * from "./SearchDialog.vue?vue&type=script&lang=js"
import style0 from "./SearchDialog.vue?vue&type=style&index=0&id=4de5b6f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de5b6f4",
  null
  
)

export default component.exports